import {RcfaStoppageCode as StoppageCode} from '@domain/shared'
import {Grid} from '@mui/material'
import moment from 'moment'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {StoppageSection} from './StoppageSection'

interface Props {
  code?: StoppageCode
  start?: string | null
  end?: string | null
  duration?: number
  dataTestId?: string
  translationNamespace?: string
}

export const StoppageGroupDetail: React.FC<Props> = ({
  code,
  start,
  end,
  duration,
  dataTestId,
  translationNamespace
}) => {
  const {t} = useTranslation(translationNamespace)

  return (
    <Grid container spacing={0.5} key={`stoppage-code-${code?.code}`} data-test-id={dataTestId}>
      <Grid item xs={2}>
        <StoppageSection label={t('stoppage.detail.asset')} value={code?.type} />
      </Grid>
      <Grid item xs={4}>
        <StoppageSection
          label={t('stoppage.detail.stoppageCode')}
          value={code?.text}
          labelBottom={`${code?.code}`}
        />
      </Grid>
      <Grid item xs={4}>
        <StoppageSection
          label={t('stoppage.detail.time')}
          value={`${formatDate(start)} - ${formatDate(end)}`}
        />
      </Grid>
      <Grid item xs={2}>
        <StoppageSection
          label={t('stoppage.detail.duration')}
          value={`${duration ? formatDurationHoursAndMins(duration) + 'h' : '-'}`}
        />
      </Grid>
    </Grid>
  )
}

const formatDurationHoursAndMins = (
  duration: number,
  unit: moment.unitOfTime.Base = 'seconds'
): string => {
  const d = moment.duration(duration, unit)
  const days = Math.trunc(d.asDays())
  let result = days > 0 ? days.toString() + 'd ' : ''
  result += `${(d.hours() + d.minutes() / 60).toFixed(2).toString().padStart(2, '0')}`
  return result
}

const formatDate = (dateTimeIso?: string | null) =>
  dateTimeIso ? moment(dateTimeIso).format('DD.MM.YYYY') : ''
